import { VideoFragment } from '@lib/umbraco/generated/types.generated'
import clsx from 'clsx'
import s from './Media.module.scss'

import React, { PropsWithChildren } from 'react'

interface Props {
  video: VideoFragment
  priority?: boolean
  inView?: boolean
}
type NativeAttrs = Omit<React.HTMLAttributes<HTMLVideoElement>, keyof Props>

export type VideoProps = Props & NativeAttrs

const Video = React.forwardRef<HTMLVideoElement, PropsWithChildren<VideoProps>>(
  ({ video, inView, priority, className, children, ...props }, ref) => {
    const loadVideo = priority === true || inView

    let videoAttributes = {
      src: undefined,
    }
    let mobileVideoAttributes = {
      src: undefined,
    }

    if (video == null) return null
    const hasDirectFileKey = video.id?.includes('.')
    // if id already has a dot, it is a key.
    if (loadVideo) {
      const isExternalVideo = video.id?.includes('https')
      videoAttributes = {
        src: isExternalVideo
          ? video.id
          : hasDirectFileKey
            ? `https://media.gubi.com/${video.id}`
            : `https://media.gubi.com/${video.id}.mp4`,
      }
      if (video.mobileVideo?.media) {
        mobileVideoAttributes = {
          //@ts-ignore
          src: `https://media.gubi.com/${video.mobileVideo.media.id}.mp4`,
        }
      } else {
        mobileVideoAttributes = videoAttributes
      }
    }

    return (
      <>
        <video
          {...props}
          ref={ref}
          preload={video.disableAutoplay ? 'metadata' : 'none'}
          role="presentation"
          playsInline
          autoPlay={!video.disableAutoplay}
          controls={video.enableControls}
          muted={!video.disableAutoplay && !video.enableSound}
          loop={!video.disableLoop}
          poster={video.thumbnailSrc || undefined}
          {...videoAttributes}
          className={clsx(className, s.desktop)}
        >
          {children}
        </video>
        <video
          {...props}
          preload={video.disableAutoplay ? 'metadata' : 'none'}
          role="presentation"
          playsInline
          autoPlay={!video.disableAutoplay}
          controls={video.enableControls}
          poster={
            video.mobileVideo?.media?.__typename === 'UmbracoMediaVideo' &&
            video.mobileVideo?.media?.thumbnailSrc
              ? video.mobileVideo.media.thumbnailSrc
              : undefined
          }
          muted={!video.disableAutoplay && !video.enableSound}
          loop={!video.disableLoop}
          {...mobileVideoAttributes}
          className={clsx(className, s.mobile)}
        >
          {children}
        </video>
      </>
    )
  },
)
Video.displayName = 'Video'
export default Video
